import { Component, OnInit, Inject, ViewEncapsulation, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MeteringPoint, MeteringPointAddress } from '@model';
import { environment } from '@environment';
import { MeteringPointType, MeteringType } from '@enums';
import { String } from 'typescript-string-operations';
import { filter, take } from 'rxjs/operators';
import { SubSink } from 'subsink';
import { SxSnackbarService } from '@services';
import { TranslateService } from '@ngx-translate/core';
import { MeteringPointService } from '@appStore/metering-points/services';
import { DisruptionInfo } from 'app/models/disruptionInfo.model';
import { ToLocalDateTimePipe } from '@utils/pipes';

@Component({
    selector: 'app-metering-point-info-dialog',
    templateUrl: './metering-point-info-dialog.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class MeteringPointInfoDialogComponent implements OnInit, OnDestroy {
  meteringPoint: MeteringPoint;
  disruptionInfo: DisruptionInfo;
  customerName: string;
  isLogical: boolean;
  apiUrl: string;

  private subs = new SubSink();

  constructor(
    public dialogRef: MatDialogRef<MeteringPointInfoDialogComponent>,
    private sxSnackbarService: SxSnackbarService,
    private translate: TranslateService,
    private meteringPointService: MeteringPointService,
    private toLocalDate: ToLocalDateTimePipe,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.meteringPoint = data.selectedMeteringPoint;
    if (this.meteringPoint.disruptionInfos && this.meteringPoint.disruptionInfos.length > 0){
      this.disruptionInfo = this.meteringPoint.disruptionInfos.find(d => !d.isRestored);
    }
    this.customerName = data.customerName;
    this.apiUrl = environment.apiEndpoint;
  }

  ngOnInit() {
    this.isLogical = this.meteringPoint.type === MeteringPointType.Logical;
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  prettyPrintAddress(address: MeteringPointAddress) {
    return (
      address.street + ' ' + address.streetNo + ', ' + address.zip + ' ' + this.capitalizeFirstLetter(address.city)
    );
  }

  capitalizeFirstLetter(str: string) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  getReport(meteringPointId: number) {
    let type = this.meteringPoint.meteringType === MeteringType.Hot ? 'Fjärrvärmerapport' : 'Fjärrkylarapport';
    let meteringPointName = this.meteringPoint.name;
    let filename = type + '-' + meteringPointId + '-' + this.capitalize(meteringPointName);
    let timestamp = this.toLocalDate.transform(new Date(), 'YYYY-MM-dd');

    let ts = '' + new Date().getTime();
    let win = window.open('about:blank', ts);
    win.location.replace('/report-download.html?ts=' + ts);
    win['selfRef'] = win;

    this.sxSnackbarService.openSnackBar(this.translate.instant('meteringpoints.info.downloading_report'), '');
    this.subs.sink = this.meteringPointService
      .createReportKey()
      .pipe(
        filter(x => !!x),
        take(1)
      )
      .subscribe(key => {
        let reportUrl = String.Format(
          '{0}/Reports/{1}/meteringpoints/{2}/summaryreport/{3}_{4}',
          this.apiUrl,
          key,
          meteringPointId,
          filename,
          timestamp
        );
        win.location.replace('/report-download.html?ts=' + ts + '&redir=' + encodeURIComponent(reportUrl));
        win['selfRef'] = win;
      });
  }

  capitalize = s => {
    if (typeof s !== 'string') {
      return '';
    }
    return s.charAt(0).toUpperCase() + s.slice(1);
  };
}
